import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-component-recommend',
  templateUrl: './docs-component-recommend.component.html',
  styleUrls: ['./docs-component-recommend.component.css']
})
export class DocsComponentRecommendComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
